export default __webpack_public_path__ + "static/media/Section3_Bg.3c744c44.png";